import { Button, DatePicker, Form, Input, message, Select } from 'antd';
import { AGE_RATING, DUBBING_MODE, STATUS } from 'constants/constant';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { peopleApiService } from 'service/api/peopleApiService';
import { PeopleInterface } from 'type/peopleType';
import * as Component from '../../../../shared/components';
import { seasonService } from '../services/seasonService';
import { I18nFormFields } from '../../../../shared/components/i18n/I18nFormFields';
import { I18nFieldData } from '../../../../shared/types/i18n/i18nTypes';

const SeasonAdd: React.FC = () => {
  const [form] = Form.useForm();
  const [searchedPeopleList, setSearchedPeopleList] = useState<PeopleInterface[]>([]);
  const navigate = useNavigate();

  const [i18nTitle, setI18nTitle] = useState<I18nFieldData>({});
  const [i18nSynopsis, setI18nSynopsis] = useState<I18nFieldData>({});
  const [i18nSecondaryTitle, setI18nSecondaryTitle] = useState<I18nFieldData>({});

  return (
    <Component.BasePageComponent>
      <div>
        <div className="season-details-page">
          <h1>Season</h1>
          <Form form={form} layout="vertical" className="season-details-form">
            {/* 다국어 제목 입력 */}
            <I18nFormFields
              fieldName="title"
              required={true}
              fieldType="input"
              value={i18nTitle}
              onChange={setI18nTitle}
            />

            <div style={{ marginTop: '16px' }}>
              <I18nFormFields
                fieldName="secondary_title"
                required={false}
                fieldType="input"
                value={i18nSecondaryTitle}
                onChange={setI18nSecondaryTitle}
              />
            </div>

            <div style={{ marginTop: '16px' }}>
              <I18nFormFields
                fieldName="synopsis"
                required={false}
                fieldType="textarea"
                value={i18nSynopsis}
                onChange={setI18nSynopsis}
              />
            </div>

            <Form.Item
              label="Slug"
              name="slug"
              rules={[{ required: true, message: 'Please enter a slug' }]}
            >
              <Input />
            </Form.Item>
            <Form.Item label="Status" name="status">
              <Select>
                {STATUS.map(status => (
                  <Select.Option key={status} value={status}>
                    {status}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="Dubbing Mode" name="dubbing_mode">
              <Select>
                {Object.entries(DUBBING_MODE).map(([key, value]) => (
                  <Select.Option key={key} value={key}>
                    {value}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="season_order"
              label="Season Order"
            >
              <Input type="number" />
            </Form.Item>
            <Form.Item label="Age Rating" name="age_rating">
              <Select>
                {AGE_RATING.map(ageRating => (
                  <Select.Option key={ageRating} value={ageRating}>
                    {ageRating}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="release_date_start" label="Release Start Date">
              <DatePicker />
            </Form.Item>
            <Form.Item name="release_date_end" label="Release End Date">
              <DatePicker />
            </Form.Item>
            {/* <Form.Item
              name="cast"
              label="Cast"
              rules={[{ required: false, message: 'Search and select Cast' }]}
            >
              <Select
                mode="multiple"
                showSearch
                placeholder="Search and select Cast"
                value={searchedPeopleList}
                onChange={value => {
                  setSearchedPeopleList(value);
                }}
                onSearch={async (value: string) => {
                  const response = await peopleApiService.fetch(
                    new URLSearchParams({
                      page: '1',
                      page_size: '1',
                      search: value,
                    })
                  );
                  setSearchedPeopleList(response.results);
                }}
                filterOption={false}
                options={searchedPeopleList.map(people => ({
                  label: people.name,
                  value: people.id,
                }))}
                style={{ width: '100%' }}
              />
            </Form.Item> */}
            <Form layout="inline">
              <Form.Item
                name="series"
                style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}
              >
                <span style={{ marginRight: 8, cursor: 'pointer' }}>Series</span>
                <Button
                  type="link"
                  onClick={() => window.open('/series', '_blank', 'noopener,noreferrer')}
                >
                  Edit
                </Button>
              </Form.Item>
            </Form>
          </Form>
        </div>
        <div className="season-detail-update-button">
          <Component.ColorButtonComponent
            text={'ADD'}
            onClick={async () => {
              try {
                await form.validateFields();
                const formData = form.getFieldsValue();
                const seasonDataWithI18n = {
                  ...formData,
                  i18n_title: i18nTitle,
                  i18n_secondary_title: i18nSecondaryTitle,
                  i18n_synopsis: i18nSynopsis,
                  // 날짜 포맷팅
                  release_date_start: formData.release_date_start
                    ? formData.release_date_start.format('YYYY-MM-DD')
                    : null,
                  release_date_end: formData.release_date_end
                    ? formData.release_date_end.format('YYYY-MM-DD')
                    : null,
                  title: i18nTitle.en || ' ',
                };

                // i18n 지원 업데이트 API 호출
                const season = await seasonService.createSeasonWithI18n(seasonDataWithI18n);
                message.success('Season created successfully');
                navigate(`/season/edit/${season.id}`);
              } catch (error) {
                console.log(error);
                message.error('Failed to create season');
              }
            }}
          />
        </div>
      </div>
    </Component.BasePageComponent>
  );
};

export default observer(SeasonAdd);
